// extracted by mini-css-extract-plugin
export var section = "section-module--section--20nC_";
export var sectionHeader = "section-module--sectionHeader--CGdiv";
export var sectionContent = "section-module--sectionContent--giQLH";